/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScriptStepStatusType = {
    Started: 'Started',
    Current: 'Current',
    Completed: 'Completed'
} as const;
export type ScriptStepStatusType = typeof ScriptStepStatusType[keyof typeof ScriptStepStatusType];


export function ScriptStepStatusTypeFromJSON(json: any): ScriptStepStatusType {
    return ScriptStepStatusTypeFromJSONTyped(json, false);
}

export function ScriptStepStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptStepStatusType {
    return json as ScriptStepStatusType;
}

export function ScriptStepStatusTypeToJSON(value?: ScriptStepStatusType | null): any {
    return value as any;
}

